const data = {
  'Selected': 'Вибрано: {0} з {1}',
  'Uploading files': 'Завантаження {0}% із {1}',
  'File size error': '{0} завеликий, будь ласка, завантажте файл менший за {1}',
  'Upload failed': '{0} не вдалося завантажити',
  'Upload summary': '{0} успішно, {1} з помилкою, {2} всього',
  'Per page': '{0} На сторінку',
  'Folder': 'Папка',
  'Login failed, please try again': 'Вхід не виконано. Будь ласка, спробуйте ще раз',
  'Already logged in': 'Вже авторизовано.',
  'Please enter username and password': 'Будь ласка, введіть ім\'я користувача та пароль.',
  'Not Found': 'Не знайдено',
  'Not Allowed': 'Не дозволено',
  'Please log in': 'Будь ласка, увійдіть',
  'Unknown error': 'Невідома помилка',
  'Add files': 'Додати файли',
  'New': 'Створити',
  'New name': 'Нове ім\'я',
  'Username': 'Ім\'я користувача',
  'Password': 'Пароль',
  'Login': 'Вхід',
  'Logout': 'Вихід',
  'Profile': 'Профіль',
  'No pagination': 'Без розбивки на сторінки',
  'Time': 'Час',
  'Name': 'Ім\'я',
  'Size': 'Розмір',
  'Home': 'Головна',
  'Copy': 'Копіювати',
  'Move': 'Перемістити',
  'Rename': 'Перейменувати',
  'Required': 'Будь ласка, заповніть це поле',
  'Zip': 'Архівувати zip',
  'Batch Download': 'Пакетне завантаження',
  'Unzip': 'Розархівувати zip архів',
  'Delete': 'Видалити',
  'Download': 'Завантажити',
  'Copy link': 'Скопіювати посилання',
  'Done': 'Готово',
  'File': 'Файл',
  'Drop files to upload': 'Перетягніть файли для завантаження',
  'Close': 'Закрити',
  'Select Folder': 'Виберіть папку',
  'Users': 'Користувачі',
  'Files': 'Файли',
  'Role': 'Ролі',
  'Cancel': 'Скасувати',
  'Paused': 'Призупинено',
  'Confirm': 'Підтвердити',
  'Create': 'Створити',
  'User': 'Користувач',
  'Admin': 'Адмін',
  'Save': 'Зберегти',
  'Read': 'Читання',
  'Write': 'Запис',
  'Upload': 'Завантаження',
  'Permissions': 'Дозволи',
  'Homedir': 'Домашня папка',
  'Leave blank for no change': 'Залиште поле порожнім, щоб не змінювати',
  'Are you sure you want to do this?': 'Ви впевнені, що хочете виконати цю дію?',
  'Are you sure you want to allow access to everyone?': 'Ви впевнені, що хочете надати доступ усім?',
  'Are you sure you want to stop all uploads?': 'Ви впевнені, що хочете зупинити всі завантаження?',
  'Something went wrong': 'Щось пішло не так',
  'Invalid directory': 'Недійсна папка',
  'This field is required': 'Це поле обов\'язкове',
  'Username already taken': 'Ім\'я користувача вже зайнято',
  'User not found': 'Користувача не знайдено',
  'Old password': 'Старий пароль',
  'New password': 'Новий пароль',
  'Wrong password': 'Невірний пароль',
  'Updated': 'Оновлено',
  'Deleted': 'Видалено',
  'Your file is ready': 'Ваш файл готовий',
  'View': 'Перегляд',
  'Search': 'Пошук',
  'Download permission': 'Завантаження',
  'Guest': 'Гість',
  'Show hidden': 'Показати приховане',
  'Show symbolic format': 'Показати символічний формат',
  'Hide symbolic format': 'Приховати символічний формат',
}

export default data
